/*
  Techno Express - variant fallback (17-oct-2026)
  When a shopper picks an option value whose combination with the other
  selected options does not exist (e.g. 3/8 IN + Matte Black), switch the
  other options to the closest existing variant instead of showing
  "Variant sold out or unavailable". Earlier options are kept when possible.
*/
(function () {
  var lastChanged = null;
  document.addEventListener('change', function (e) { lastChanged = e.target; }, true);

  function patch(VS) {
    var proto = VS && VS.prototype;
    if (!proto || proto.__txFallback) return;
    proto.__txFallback = true;
    var original = proto.updateMasterId;

    proto.updateMasterId = function () {
      original.call(this);
      if (this.currentVariant || this.__txFixing) return;
      if (this.dataset.isHighVariantProduct === 'true') return;

      var target = lastChanged && this.contains(lastChanged) ? lastChanged : null;
      if (!target || (target.dataset && target.dataset.productUrl)) return;

      var variants = this.getVariantData ? this.getVariantData() : null;
      if (!variants || !variants.length || !this.options) return;

      var fieldsets = Array.prototype.slice.call(this.querySelectorAll('.product-form__controls'));
      var changedIdx = -1;
      for (var f = 0; f < fieldsets.length; f++) {
        if (fieldsets[f].contains(target)) { changedIdx = f; break; }
      }
      if (changedIdx < 0) return;

      var current = this.options.slice();
      var candidates = variants.filter(function (v) { return v.options[changedIdx] === current[changedIdx]; });
      if (!candidates.length) return;

      function score(v) {
        var s = v.available ? 10000 : 0;
        v.options.forEach(function (val, i) {
          if (i !== changedIdx && val === current[i]) s += (i < changedIdx ? 100 : 1);
        });
        return s;
      }
      var best = candidates[0];
      candidates.forEach(function (v) { if (score(v) > score(best)) best = v; });

      best.options.forEach(function (val, i) {
        var fs = fieldsets[i];
        if (!fs) return;
        var radios = fs.querySelectorAll('input[type="radio"]');
        for (var r = 0; r < radios.length; r++) {
          if (radios[r].value === val) { radios[r].checked = true; break; }
        }
        var select = fs.querySelector('select');
        if (select) select.value = val;
      });

      this.__txFixing = true;
      try {
        this.updateOptions();
        original.call(this);
      } finally {
        this.__txFixing = false;
      }
    };
  }

  if (window.customElements) {
    customElements.whenDefined('variant-selects').then(function () {
      patch(customElements.get('variant-selects'));
    });
  }
})();
